"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaitListUploadDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const file_input_1 = require("./file-input");
const WaitListUploadDialog = (props) => {
    const { selectedItem } = props;
    if (!selectedItem) {
        return null;
    }
    return (0, jsx_runtime_1.jsx)(file_input_1.FileInput, { initialValues: selectedItem });
};
exports.WaitListUploadDialog = WaitListUploadDialog;
//# sourceMappingURL=index.js.map